import { OperationResult } from '../common/__generated__/api';

const SINGLE_RETRY = 1;

export function fetchWithRetry(operation: Promise<OperationResult<any>>, retries: number): any {
  return operation.catch(error => {
    if (retries > 0) {
      fetchWithRetry(operation, retries - SINGLE_RETRY);
    }

    return Promise.reject(error);
  });
}
